import React from 'react';

export default function OptionsList({ options, onAdd, onRemove, onModify }) {
  return (
    <div className="grid">
      <div className="col-12">
        {options.map((option, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "flex-end",
              marginTop: "8px",
            }}
          >
            <div style={{ flex: 2 }}>
              <input
                className="clean-input"
                value={option.titre}
                onChange={(e) => onModify(index, "titre", e.target.value)}
                placeholder="Titre de l'option"
              />
            </div>
            <div style={{ flex: 2 }}>
              <input
                className="clean-input"
                value={option.description}
                onChange={(e) => onModify(index, "description", e.target.value)}
                placeholder="Description"
              />
            </div>
            <div style={{ width: "85px" }}>
              <input
                type="number"
                className="clean-input"
                value={option.prix}
                onChange={(e) => onModify(index, "prix", parseFloat(e.target.value) || 0)}
                placeholder="Prix €"
                min={0}
              />
            </div>
            <button
              onClick={() => onRemove(index)}
              style={{
                height: "38px",
                width: "38px",
                border: "1px solid #e5e7eb",
                borderRadius: "6px",
                background: "#ffffff",
                color: "#9ca3af",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>
        ))}

        <button
          onClick={onAdd}
          style={{
            background: "none",
            border: "1px dashed #d1d5db",
            borderRadius: "6px",
            width: "100%",
            padding: "8px",
            marginTop: "10px",
            fontSize: "13px",
            color: "#322915",
            cursor: "pointer",
          }}
        >
          + Ajouter une option
        </button>
      </div>
    </div>
  );
}